'use strict';

//directive main function
VinDecodeDirective.$inject = [];

function VinDecodeDirective() {
    var directive = {
        restrict: 'E',
        replace: 'true',
        scope: {
            decodeHandler: '&?',
            decodeStart: '&?',
            decodeEnd: '&?',
            ngRequired: '=?',
            normalizeUrl: '=',
            showTitle: '<?'
        },
        controller: VinDecodeDirectiveController,
        templateUrl: 'template/directives/vin-decode'
    }
    return directive;
};

//directive controller function
VinDecodeDirectiveController.$inject = ['$scope', '$state', '$log', 'apiService', 'VehicleService', 'customerModelService', 'bootstrapParameters', '$timeout', '$q', 'VALIDATION', 'errorRouterService'];

function VinDecodeDirectiveController($scope, $state, $log, apiService, vehicleService, customerModelService, bootstrapParameters, $timeout, $q, VALIDATION, errorRouterService) {
    $scope.vinPattern = VALIDATION.VIN_NUMBER;

    var vinDecodeErrorListener = errorRouterService.subscribe(function () {
        return $q.when(true);
    }, {method: 'GET', resourceName: 'decodeVin', status: '500'});

    if ($scope.ngRequired) {
        $scope.vinNumber = $scope.ngRequired;
    }

    //toggleHelpPopup
    //
    //@description
    //Set flag to show or hide popup where user get the information where he or she may
    //find the vin of his vehicle
    $scope.toggleHelpPopup = function () {
        $scope.showHelpPopup = !!!$scope.showHelpPopup
    }

    //decode
    //
    //@description
    //Decode entered vin number
    $scope.decode = function () {
        if (!$scope.vinForm.$valid) {
            return;
        } else {
            $scope.decodeStart && $scope.decodeStart();
            var telematicsData;
            apiService.getCatalog()
                .then(async function (catalog) {
                    // Get jsonData object reading from Telematics
                    if (window.appSettings.telematicsMileageEnabled || window.appSettings.ossShowVehicleAlerts) {
                        await catalog.getVehicleTelematics($scope.vinNumber).then(function (telematicsJsonData) {
                            if (telematicsJsonData){
                                telematicsData = telematicsJsonData;
                            }
                        });
                    }
                    return catalog.decodeVin($scope.vinNumber);
                })
                .then(function (vehicle) {
                    return $q.all([
                        vehicleService.setVehicleDetails(vehicle),
                        customerModelService.searchCustomer($scope.vinNumber, true)
                    ]);
                })
                .then(function (res) {
                    var currentVehicle = res[0];
                    var customers = res[1];
                    if (customers.length) {
                        currentVehicle.setVinNumber(null);
                        $scope.vinNumber = '';
                        $scope.vinForm.$setPristine();
                    }
                    customerModelService.setCurrentVehicle(currentVehicle);
                    customerModelService.setVehicleCreationData({});
                    if (telematicsData){
                        var customerModelCurrentVehicle = customerModelService.getCurrentVehicle();
                        customerModelCurrentVehicle.setTelematicsData(telematicsData);
                    }
                    return customerModelService.resolveRecallsUpdates();
                })
                .then(function (recalls) {
                    if (_.size(recalls)) {
                        $scope.recalls = true;
                    } else {
                        $scope.recalls = false;
                    }
                    return customerModelService.resolveProtectionPlansUpdates();
                })
                .then(function (protectionPlans) {
                    if (_.size(protectionPlans)) {
                        $scope.protectionPlans = true;
                    } else {
                        $scope.protectionPlans = false;
                    }
                    return customerModelService.resolveAlertsUpdates();
                })
                .then(function (alerts){
                    if (_.size(alerts) || $scope.recalls || $scope.protectionPlans){
                        $state.go('checkhealth');
                    } else {
                        $scope.decodeHandler && $scope.decodeHandler();
                    }
                })
                .catch(function (err) {
                    $scope.vinForm.vinField.$setValidity('decodeFailed', false);
                })
                .finally(function () {
                    $scope.decodeEnd && $scope.decodeEnd();
                });
        }
    };

    $scope.onVinChange = function () {
        if ($scope.vinForm) {
            $scope.vinForm.vinField.$setValidity('decodeFailed', true);
        }
    };

    $scope.$on('$destroy', function () {
        errorRouterService.unsubscribe(vinDecodeErrorListener);
    });
};

module.exports = VinDecodeDirective;
